<template>
  <div class="blog">
    <!-- start header -->
    <div class="header">
      <div class="layer">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="../assets/images/blog/header/eight.jpg" class="d-block w-100" alt="...">
              <div class="carousel-caption d-none d-md-block">
                <h6>CLIENTS TRUST</h6>
                <h3>CUSTOMERS TRUST OF OUR SAFTEY</h3>
                <span>JANUARY 20</span>
                <span>|</span>
                <span>3 comments</span>
              </div>
            </div>
            <div class="carousel-item">
              <img src="../assets/images/blog/header/six.jpg" class="d-block w-100" alt="...">
              <div class="carousel-caption d-none d-md-block">
                <h6>EASY DEALING</h6>
                <h3>EASILY REACH AND DEAL WITH US</h3>
                <span>MARCH 13</span>
                <span>|</span>
                <span>27 comments</span>
              </div>
            </div>
            <div class="carousel-item">
              <img src="../assets/images/blog/header/fourth.jpg" class="d-block w-100" alt="...">
              <div class="carousel-caption d-none d-md-block">
                <h6>MANY BRANCHES</h6>
                <h3>YOU CAN FIND US ALL OVER THE WORLD</h3>
                <span>MAY 28</span>
                <span>|</span>
                <span>140 comments</span>
              </div>
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
            <p class="carousel-control-prev-icon" aria-hidden="true"></p>
            <p class="sr-only">Previous</p>
          </a>
          <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
            <p class="carousel-control-next-icon" aria-hidden="true"></p>
            <p class="sr-only">Next</p>
          </a>
        </div>
      </div>
    </div>
    <!-- end header -->
    <!-- start section 1 -->
    <div class="section1">
      <div class="container">
        <div class="row">
          <div class="col-lg-7">
            <div class="first1">
              <img src="../assets/images/blog/section1/sec1111.jpg" alt="">
              <div class="info1">
                <span>PHOTOGRAPHY</span>
                <h3>how to make your journey remembable</h3>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quasi maxime recusandae, a molestias illum repellendus unde, neque debitis</p>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="first2">
              <div class="features">
                <div class="img">
                  <img src="../assets/images/blog/section1/to2.jpg" alt="">
                </div>
                <div class="info2">
                  <span>PHOTOGRAPHY</span>
                  <h5>take photos and make your travels remembable</h5>
                </div>
              </div>
            </div>
            <div class="first2">
              <div class="features">
                <div class="img">
                  <img src="../assets/images/blog/section1/to.jpg" alt="">
                </div>
                <div class="info2">
                  <span>LIFESTYLE</span>
                  <h5>have a way to understand everything in the world</h5>
                </div>
              </div>
            </div>
            <div class="first2">
              <div class="features">
                <div class="img">
                  <img src="../assets/images/blog/section1/to3.jpg" alt="">
                </div>
                <div class="info2">
                  <span>SAFTEY</span>
                  <h5>make sure you will be safe with us</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 1 -->
    <!-- start section 2 --> 
    <div class="section2">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="sec2img">
              <img src="../assets/images/blog/section2/sec2.jpg" alt="">
              <div class="life">
                <h5>OUR STYLE</h5>
                <span>JANUARY 10 2020</span>
                <span>|</span>
                <span>ADMIN</span>
                <h4>our style is making you feel comfort</h4>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis quis accusamus nemo! Aliquid facilis dolore voluptatem totam fuga nam iure dolorem necessitatibus! Eaque hic.</p>
                <p class="comment"><i class="far fa-comment"></i> comment</p>
                <p class="share"><i class="fas fa-share-alt"></i> facebook, twitter, instaugram</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <h6>FEATURED POSTS</h6>
            <div class="post">
              <img src="../assets/images/blog/section2/sec22.jpg" alt="">
              <span>OCTOBER 15, 2018</span>
              <h4>we help you to get to your destination</h4>
            </div>
            <div class="post">
              <img src="../assets/images/blog/section2/sec222.jpg" alt="">
              <span>MARCH 23, 2018</span>
              <h4>we make everything in professional way</h4>
            </div>
            <div class="post">
              <i class="fab fa-twitter"></i>
              <span>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ducimus saepe reiciendis non...</span>
              <a href="">10 AM, 18 SEP</a>
            </div>
            <div class="post">
              <i class="fab fa-twitter"></i>
              <span>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ducimus saepe reiciendis non...</span>
              <a href="">3 PM, 11 OCT</a>
            </div>
            <div class="post">
              <i class="fab fa-twitter"></i>
              <span>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ducimus saepe reiciendis non...</span>
              <a href="">19 PM, 27 DEC</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 2 -->
    <!-- start section 3 -->
    <div class="section3">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="video">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/_RMnJlGjGfk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <h4>TRY TO VISIT SINGAPORE, IT HAS ALOT OF SIGHTS YOU NEVER IMAGINE...</h4>
              <span><i class="fas fa-calendar-alt"></i> 10th february  /  <i class="fas fa-user-cog"></i> admin  /  <i class="far fa-folder-open"></i> general, media  /  <i class="far fa-comments"></i> 13 comments  /  <i class="fab fa-instagram"></i> instaugram</span>
              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cum earum ducimus mollitia eaque nobis! Amet, eveniet! Ea sed est odio iste deserunt error alias quo, incidunt vitae explicabo provident accusantium.</p>
              <a><span></span> read more</a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="photos">
              <h6>PHOTOS OF INSTAUGRAM</h6>
              <img src="../assets/images/blog/section3/one.jpg" alt="">
              <img src="../assets/images/blog/section3/two.jpg" alt="">
              <img src="../assets/images/blog/section3/three.jpg" alt="">
              <img src="../assets/images/blog/section3/four.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 3 -->
    <!-- start section 4 -->
    <div class="section4">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="slide">
              <div id="carouselExampleCaptions" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                  <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>
                  <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>
                  <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>
                </ol>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img src="../assets/images/blog/section4/three.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                      <h5>will not wait</h5>
                      <p>very quickly to deal and travel properly</p>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img src="../assets/images/blog/section4/two.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                      <h5>professional dealing</h5>
                      <p>you will deal with professional employees</p>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <img src="../assets/images/blog/section4/one.jpg" class="d-block w-100" alt="...">
                    <div class="carousel-caption d-none d-md-block">
                      <h5>creative ideas</h5>
                      <p>we have super creative ideas for your travels</p>
                    </div>
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="tags">
              <h6>TAGS CLOUD</h6>
              <ul class="list-unstyled">
                <li>future</li>
                <li>native</li>
                <li>nature</li>
                <li>easy</li>
                <li>quick</li>
                <li>professional</li>
                <li>respect</li>
                <li>timing</li>
                <li>uniform</li>
                <li>style</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 4 -->
    <!-- start section -->
    <div class="section5">
      <div class="container">
        <div class="row">
          <div class="col-lg-4">
            <div class="way">
              <img src="../assets/images/blog/section5/sec5.jpg" alt="">
              <span>APRIL 12, 2018</span>
              <h5>JUMO is the best way to travel</h5>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="things">
              <img src="../assets/images/blog/section5/sec55.jpg" alt="">
              <div class="inf">
                <span>JAN 15, 11 PM</span>
                <p>jumo is amazing agency</p>
              </div>
            </div>
            <div class="things">
              <img src="../assets/images/blog/section5/sec555.jpg" alt="">
              <div class="inf">
                <span>JAN 15, 11 PM</span>
                <p>jumo is amazing agency</p>
              </div>
            </div>
            <div class="things">
              <img src="../assets/images/blog/section5/sec5555.jpg" alt="">
              <div class="inf">
                <span>JAN 15, 11 PM</span>
                <p>jumo is amazing agency</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="comments">
              <div class="comment">
                <span class="name">jack watson</span>
                <span>Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
              </div>
              <div class="comment">
                <span class="name">jack watson</span>
                <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam repudiandae unde</span>
              </div>
              <div class="comment">
                <span class="name">jack watson</span>
                <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid quos deleniti eveniet repudiandae temporibus eligendi</span>
              </div>
              <div class="comment">
                <span class="name">jack watson</span>
                <span>Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
              </div>
              <div class="comment">
                <span class="name">jack watson</span>
                <span>Lorem ipsum, dolor sit amet consectetur adipisicing elit</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 5 -->
    <!-- start footer -->
    <app-footer></app-footer>
    <!-- end footer -->
  </div>
</template>

<style scoped lang="scss">
@import '../css/variables.scss';
@import '../css/mixins.scss';
/* start header */ 
.header {
  margin-top: -20px;
  .layer {
    .carousel-item {
      width: 100%;
      height: 661px;
      img {
        filter: brightness(0.4);
      }
      .carousel-caption {
        background-color: rgba(0, 0, 0, 0.7);
        width: 50%;
        margin: auto;
        bottom: 70px;
        padding: 40px;
        span {
          font-size: 15px;
          margin-right: 20px;
        }
      }
    }
    .carousel-control-prev, .carousel-control-next {
      p {
        background-color: rgba(0, 0, 0, 0.7);
        width: 80px;
        height: 90px;
        &:hover {
          background-color: $maincolor;
          color: #fff;
        }
        &.carousel-control-next-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='-6 -6 20 20'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e")
        }
        &.carousel-control-prev-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='-6 -6 20 20'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e")
        }
      }
    }
  }
  /* start media query of header */ 
  @include mb {
    .layer {
      .carousel-item {
        height: 300px;
        img {
          height: 100%;
        }
      }
      .carousel-control-prev, .carousel-control-next {
        p {
          width: 50px;
          height: 60px;
        }
      }
    }
  }
  @include sm {
    .layer {
      .carousel-item {
        height: 550px;
        img {
          height: 100%;
        }
        .carousel-caption {
          bottom: 50px;
        }
      }
      .carousel-control-prev, .carousel-control-next {
        p {
          background-color: rgba(0, 0, 0, 0.7);
          width: 60px;
          height: 70px;
        }
      }
    }
  }
  /* end media query of header */ 
}
/* end header */ 
/* start section 1 */ 
.section1 {
  margin-top: 80px;
  text-align: left;
  .first1 {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 350px;
      filter: brightness(0.7);
      border-radius: 5px;
      transition: all 0.3s ease-in-out;
    }
    .info1 {
      color: #fff;
      position: absolute;
      bottom: -18%;
      left: 20px;
      transition: all 0.3s ease-in-out;
      span {
        font-size: 13px;
        background-color: #000;
        padding: 5px;
        border-radius: 5px;
      }
      h3 {
        margin-bottom: 20px;
        font-size: 25px;
        font-weight: bold;
        margin-top: 5px;
      }
      p {
        font-size: 15px;
        color: #d3d3d3;
        font-weight: bold;
      }
    }
    &:hover {
      img {
        filter: brightness(0.5);
      }
      .info1 {
        bottom: 3%;
      }
    }
  }
  .first2 {
    margin-bottom: 10px;
    .features {
      display: flex;
      img {
        width: 160px;
        height: 110px;
        border-radius: 5px;
        margin-right: 15px;
      }
      .info2 {
        margin-top: 15px;
        span {
          margin: 0;
          font-size: 11px;
          background-color: $secondcolor;
          color: #fff;
          padding: 5px;
          border-radius: 5px;
        }
        h5 {
          margin-top: 10px;
          font-size: 19px;
          font-weight: bold;
        }
      }
    }
  }
  /* start media query of section 1 */ 
  @include mb {
    .first1 {
      margin-bottom: 40px;
      height: 250px;
      img {
        height: 250px;
      }
      .info1 {
        top: 70%;
        left: 10px;
        transition: all 0.3s ease-in-out;
        span {
          font-size: 10px;
        }
        h3 {
          margin-bottom: 6%;
          font-size: 18px;
        }
        p {
          font-size: 11px;
        }
      }
      &:hover {
        .info1 {
          top: 100px;
        }
      }
    }
    .first2 {
      .features {
        display: block;
        img {
          width: 260px;
          margin: 10px auto 0;
          height: 170px;
        }
        .info2 {
          margin-bottom: 25px;
          span {
            font-size: 10px;
          }
          h5 {
            margin-top: 10px;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }
  @include sm {
    .first1 {
      margin-bottom: 60px;
    }
  }
  @include md {
    .first1 {
      .info1 {
        color: #fff;
        position: absolute;
        bottom: -23%;
        span {
          font-size: 11px;
        }
        h3 {
          margin-bottom: 10px;
        }
      }
    }
    .first2 {
      .features {
        img {
          width: 140px;
          height: 100px;
        }
        .info2 {
          span {
            font-size: 10px;
          }
          h5 {
            margin-top: 10px;
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }
  /* end media query of section 1 */
}
/* end section 1 */
/* start section 2 */ 
.section2 {
  margin-top: 80px;
  .sec2img {
    img {
      width: 100%;
      height: 350px;
      border-radius: 5px;
      filter: brightness(0.8);
    }
    .life {
      background-color: #fff;
      box-shadow: 2px 10px 30px rgba(0, 0, 0, 0.1);
      width: 85%;
      margin: auto;
      padding: 10px 30px 30px 30px;
      transform: translateY(-70px);
      h5 {
        background-color: $maincolor;
        color: #fff;
        padding: 13px 10px;
        font-size: 20px;
        transform: translateY(-35px);
        width: 150px;
        margin: auto;
      }
      span {
        color: $textcolor;
        font-size: 14px;
        font-weight: bold;
        margin-left: 10px;
      }
      h4 {
        font-weight: bold;
        color: $secondcolor;
      }
      p {
        font-size: 15px;
        color: $textcolor;
      }
      .comment, .share {
        display: inline-block;
        margin: 20px 8% 0 8%;
        color: $textcolor;
        font-weight: bold;
        i {
          background-color: $maincolor;
          color: #fff;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          line-height: 30px;
          margin-right: 4px;
        }
      }
    }
  }
  h6 {
    color: $textcolor;
    font-weight: bold;
    margin-bottom: 20px;
    color: $secondcolor;
  }
  .post {
    text-align: left;
    width: 70%;
    margin: auto;
    margin-bottom: 40px;
    img {
      width: 100%;
      height: 150px;
      margin-bottom: 10px;
    }
    span {
      color: $textcolor;
      font-size: 13px;
      font-weight: bold;
    }
    h4 {
      font-size: 19px;
      font-weight: bold;
    }
    i {
      color: rgb(78, 152, 212);
      margin-right: 10px;
      font-size: 20px;
    }
    a {
      display: block;
      font-size: 13px;
      font-weight: bold;
      margin-top: 5px;
    }
  }
  /* start media query of section 2 */ 
  @include mb {
    .sec2img {
      img {
        height: 250px;
      }
      .life {
        padding: 10px 10px 30px 10px;
        transform: translateY(-70px);
        h5 {
          font-size: 13px;
          transform: translateY(-30px);
          width: 100px;
        }
        span {
          font-size: 10px;
        }
        h4 {
          font-size: 18px;
        }
        p {
          font-size: 12px;
        }
        .comment, .share {
          display: block;
          margin: 10px 1% 0 1%;
          font-size: 12px;
          text-align: left;
          i {
            background-color: $maincolor;
            color: #fff;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 20px;
            margin-right: 4px;
            font-size: 11px;
            text-align: center;
          }
        }
      }
    }
    h6 {
      font-size: 14px;
    }
    .post {
      span {
        font-size: 11px;
      }
      h4 {
        font-size: 16px;
      }
      a {
        font-size: 10px;
      }
    }
  }
  @include sm {
    .sec2img {
      .life {
        .comment, .share {
          margin: 10px 7% 0 7%;
          font-size: 14px;
          text-align: left;
          i {
            width: 30px;
            height: 30px;
            line-height: 30px;
            font-size: 15px;
            text-align: center;
          }
        }
      }
    }
    h6 {
      font-size: 16px;
    }
    .post {
      width: 350px;
      img {
        height: 200px;
      }
    }
  }
  @include md {
    .sec2img {
      .life {
        .comment, .share {
          margin: 10px 5% 0 5%;
          font-size: 14px;
          text-align: left;
          i {
            width: 30px;
            height: 30px;
            line-height: 30px;
            font-size: 15px;
            text-align: center;
          }
        }
      }
    }
  }
  /* end media query of section 2 */
}
/* end section 2 */
/* start section 3 */ 
.section3 {
  .video {
    transform: translateY(-330px);
    text-align: left;
    iframe {
      width: 100%;
      height: 350px;
    }
    h4 {
      font-weight: bold;
      font-size: 22px;
      margin-top: 10px;
    }
    span {
      color: rgb(109, 109, 109);
      font-weight: bold;
      font-size: 15px;
    }
    p {
      color: $textcolor;
      margin-top: 10px;
    }
    a {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      span {
        width: 30%;
        position: absolute;
        height: 3px;
        bottom: -5px;
        left: 0;
        background-color: $maincolor;
        transition: all 0.3s ease-in-out;
      }
      &:hover {
        color: $maincolor;
        span {
          width: 100%;
        }
      }
    }
  }
  .photos {
    margin-top: 50px;
    h6 {
      color: $secondcolor;
      font-weight: bold;
      margin-bottom: 30px;
    }
    img {
      width: 40%;
      height: 100px;
      margin: 3px;
    }
  }
  /* start media query of section 3 */ 
  @include mb {
    .video {
      transform: translateY(0);
      iframe {
        height: 250px;
      }
      h4 {
        font-size: 18px;
      }
      span {
        font-size: 13px;
      }
      p {
        font-size: 12px;
      }
      a {
        font-size: 14px;
        span {
          height: 2px;
        }
      }
    }
    .photos {
      h6 {
        font-size: 15px;
      }
    }
  }
  @include sm {
    .video {
      transform: translateY(0);
      margin-top: 40px;
    }
    .photos {
      img {
        width: 150px;
      }
    }
  }
  /* end media query of section 3 */ 
}
/* end section 3 */
/* start section 4 */
.section4 {
  .slide {
    transform: translateY(-120px);
    .carousel {
      width: 100%;
      height: 400px;
      img {
        height: 400px;
        filter: brightness(0.7)
      }
    }
  }
  .tags {
    transform: translateY(-180px);
    width: 70%;
    margin: auto;
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 10px;
    h6 {
      font-weight: bold;
      color: $secondcolor;
    }
    ul {
      margin-top: 20px;
      li {
        display: inline-block;
        border: 1px solid #ccc;
        padding: 3px 8px;
        margin: 5px;
        border-radius: 5px;
        font-size: 14px;
        &:hover {
          background-color: rgb(240, 240, 240);
        }
      }
    }
  }
  /* start media query of section 4 */ 
  @include mb {
    .slide {
      transform: translateY(30px);
      .carousel {
        width: 100%;
        height: 250px;
        img {
          height: 250px;
        }
      }
    }
    .tags {
      transform: translateY(100px);
      h6 {
        font-weight: bold;
        color: $secondcolor;
      }
      ul {
        margin-top: 20px;
        li {
          padding: 3px 8px;
          border-radius: 5px;
          font-size: 11px;
        }
      }
    }
  }
  @include sm {
    .slide {
      transform: translateY(40px);
    }
    .tags {
      transform: translateY(150px);
      margin-bottom: 50px;
    }
  }
  /* end media query of section 4 */ 
}
/* end section 4 */
/* start section 5 */ 
.section5 {
  margin-top: -150px;
  .way {
    text-align: left;
    img {
      width: 100%;
      height: 250px;
      margin-bottom: 10px;
    }
    span {
      color: rgb(155, 155, 155);
      font: {
        size: 13px;
        weight: bold;
      }
    }
    h5 {
      font: {
        weight: bold;
      }
      color: $secondcolor;
    }
  }
  .things {
    display: flex;
    text-align: left;
    margin-bottom: 10px;
    margin-top: 10px;
    img {
      width: 110px;
      height: 70px;
      margin-right: 20px;
    }
    .inf {
      margin-top: 8px;
      span {
        color: rgb(163, 163, 163);
        font: {
          weight: bold;
          size: 13px;
        }
      }
      p {
        font: {
          weight: bold;
        }
      }
    }
  }
  .comments {
    margin-top: -70px;
  }
  .comment {
    text-align: left;
    margin-bottom: 20px;
    span {
      font-size: 14px;
      color: rgb(112, 112, 112);
      &.name {
        font: {
          weight: bold;
        }
        color: #000;
        margin-right: 8px;
      }
    }
  }
  /* start media query of section 5 */
  @include mb {
    margin-top: 140px;
    .way {
      margin-bottom: 40px;
      img {
        height: 200px;
      }
      span {
        font: {
          size: 11px;
        }
      }
      h5 {
        font-size: 17px;
      }
    }
    .things {
      img {
        margin-right: 10px;
      }
      .inf {
        margin-top: 2px;
        span {
          color: rgb(163, 163, 163);
          font: {
            weight: bold;
            size: 11px;
          }
        }
        p {
          font: {
            size: 14px;
          }
        }
      }
    }
    .comments {
      margin-top: 30px;
    }
  }
  @include sm {
    margin-top: 160px;
    .way {
      margin-bottom: 40px;
      img {
        height: 300px
      }
      span {
        font: {
          size: 11px;
        }
      }
      h5 {
        font-size: 17px;
      }
    }
    .things {
      display: inline-block;
      margin-left: 30px;
      img {
        margin-right: 10px;
        width: 170px;
        height: 100px;
      }
      .inf {
        margin-top: 2px;
        span {
          color: rgb(163, 163, 163);
          font: {
            weight: bold;
            size: 11px;
          }
        }
        p {
          font: {
            size: 14px;
          }
        }
      }
    }
    .comments {
      margin-top: 30px;
    }
  }
  /* end media query of section 5 */ 
}
/* end section 5 */ 
</style>

<script>
import footer from '../components/footer'
export default {
  data() {
    return {

    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.state.Loading = true;
    setTimeout( () => {
      this.$store.state.Loading = false;
    }, 1000);
  },
  components: {
    "app-footer": footer
  }
}
</script>